import SettingsField from '@common/forms/SettingsField'
import { usePermissionText, useTranslate } from '@common/hooks'
import ModalFooter from '@common/widgets/ModalFooter'
import { useFormContext } from 'react-hook-form'

import classNames from './styles.module.scss'


interface IProps {
  onClose: () => void,
  onHide: () => void,
  permissions: IPermissionKeyed[],
}

export default function ModalContent({
  onClose,
  onHide,
  permissions,
}: IProps): JSX.Element {
  const { translate } = useTranslate()
  const { getPermissionText } = usePermissionText()
  const { formState: { isSubmitting } } = useFormContext()
  return (
    <>
      <main className={classNames.wrapper}>
        <p className={classNames.message}>{translate('The app you are adding is requesting the following permissions')}</p>
        {
          permissions?.map((permission, ind) => (
            permission.showWarningAlreadyUsed
              ? <SettingsField
                type="permission"
                name={permission.key}
                key={permission.key}
                label={translate(permission.label)}
                description={getPermissionText(permission)}
                data-test={`${permission.key}-field`}
                tabIndex={300 + ind}
              />
              : null
          ))
        }
       </main>
       <ModalFooter
        onHide={onHide}
        onClose={onClose}
        isSubmitting={isSubmitting}
      />
    </>
  )
}
